import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import CamdetectParkinglocationsModel from './CamdetectParkinglocationsModel';
import ParkinglocationModel from './ParkinglocationModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/camdetect/cameras';

export default new class CamdetectCamerasModel {

  constructor() { }

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, { id: id }));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(camdetectParkinglocationId = null) {
    var filter = {};
    if (camdetectParkinglocationId) {
      filter = _.merge(filter, { where: { and: [{ parkingLocationID: camdetectParkinglocationId }] } });
    }
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken(),
          filter: filter
        }
      })
        .then((response) => {
          Promise.all([CamdetectParkinglocationsModel.getAll(), ParkinglocationModel.getAll(true)])
            .then((r) => {
              let camdetectParkingLocations = r[0];
              let parkingLocations = r[1];
              let data = [];
              response.data.map(async (child, idx) => {
                let tLocation = _.find(camdetectParkingLocations, { id: child.parkingLocationID });
                if (!tLocation || tLocation === undefined) {
                  data.push(Object.assign({}, child, { parkingLocationName: 'Neznámá lokalita' }));
                } else {

                  let location = _.find(parkingLocations, { id: tLocation.coreParkingLocationID });
                  location
                    ? data.push(Object.assign({}, child, { parkingLocationName: location.Code + ' - ' + location.Name }))
                    : data.push(Object.assign({}, child, { parkingLocationName: 'Neznámá lokalita' }));
                }
              });
              resolve(data);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  create(data) {
    if (data.confirmPassword !== undefined) {
      delete data.confirmPassword;
    }
    return new Promise((resolve, reject) => {
      axios.post(BASE, Object.assign({}, data, { occ: 0 }), {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + id, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  update(id, data) {
    if (data.id !== undefined) {
      delete data.id;
    }
    return new Promise((resolve, reject) => {
      axios.put(BASE + '/' + id, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  patch(id, data) {
    if (data.id !== undefined) {
      delete data.id;
    }
    if (data.confirmPassword !== undefined) {
      delete data.confirmPassword;
    }
    return new Promise((resolve, reject) => {
      axios.patch(BASE + '/' + id, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/CamdetectCamerasModel.js